import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ============================================
// CRITICAL: Set SEO meta tags IMMEDIATELY (synchronously)
// This runs before any async code to ensure crawlers see it
// ============================================
// Detect language from URL path
const currentPath = window.location.pathname;
let currentLang = 'en';
if (currentPath.startsWith('/ru')) currentLang = 'ru';else if (currentPath.startsWith('/ua') || currentPath.startsWith('/uk')) currentLang = 'ua';
// SEO data for each language
const seoData: Record<string, {
  title: string;
  description: string;
}> = {
  en: {
    title: 'Website Design & Development for £299 | it Marker',
    description: 'Modern business website for £299. Get a free preview in 1–3 days, request edits, and pay only if you approve. Remote team, worldwide.'
  },
  ru: {
    title: 'Сайт под ключ за £299 — бесплатное демо | it Marker',
    description: 'Современный сайт для бизнеса за £299. Сначала делаем бесплатное демо (1–3 дня), вносим правки, и вы платите только после согласования.'
  },
  ua: {
    title: 'Сайт під ключ за £299 — безкоштовне демо | it Marker',
    description: 'Сучасний сайт для бізнесу за £299. Спочатку робимо безкоштовне демо (1–3 дні), вносим правки, і ви сплачуєте лише після погодження.'
  }
};
const seo = seoData[currentLang] || seoData.en;
// Set document title IMMEDIATELY
document.title = seo.title;
// Set lang attribute
document.documentElement.lang = currentLang === 'ua' ? 'uk' : currentLang;
// Create and insert meta description
const metaDesc = document.createElement('meta');
metaDesc.name = 'description';
metaDesc.content = seo.description;
document.head.appendChild(metaDesc);
// Calculate URLs
const baseUrl = 'https://jetly.agency';
const langPrefix = currentLang === 'en' ? '' : `/${currentLang}`;
let pagePath = currentPath;
if (currentPath.startsWith('/ru') || currentPath.startsWith('/ua') || currentPath.startsWith('/uk')) {
  pagePath = currentPath.substring(3) || '';
}
const canonicalUrl = `${baseUrl}${langPrefix}${pagePath}`;
// Canonical
const linkCanonical = document.createElement('link');
linkCanonical.rel = 'canonical';
linkCanonical.href = canonicalUrl;
document.head.appendChild(linkCanonical);
// Open Graph tags
const ogMeta = [{
  property: 'og:title',
  content: seo.title
}, {
  property: 'og:description',
  content: seo.description
}, {
  property: 'og:url',
  content: canonicalUrl
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:site_name',
  content: 'Jetly Agency'
}, {
  property: 'og:locale',
  content: currentLang === 'en' ? 'en_US' : currentLang === 'ru' ? 'ru_RU' : 'uk_UA'
}];
ogMeta.forEach(({
  property,
  content
}) => {
  const meta = document.createElement('meta');
  meta.setAttribute('property', property);
  meta.content = content;
  document.head.appendChild(meta);
});
// Twitter Card tags
const twitterMeta = [{
  name: 'twitter:card',
  content: 'summary_large_image'
}, {
  name: 'twitter:title',
  content: seo.title
}, {
  name: 'twitter:description',
  content: seo.description
}];
twitterMeta.forEach(({
  name,
  content
}) => {
  const meta = document.createElement('meta');
  meta.name = name;
  meta.content = content;
  document.head.appendChild(meta);
});
// Hreflang tags
const langs = ['en', 'ru', 'ua'];
langs.forEach(l => {
  const link = document.createElement('link');
  link.rel = 'alternate';
  link.hreflang = l === 'ua' ? 'uk' : l;
  link.href = `${baseUrl}${l === 'en' ? '' : `/${l}`}${pagePath}`;
  document.head.appendChild(link);
});
// x-default
const xDefaultLink = document.createElement('link');
xDefaultLink.rel = 'alternate';
xDefaultLink.hreflang = 'x-default';
xDefaultLink.href = `${baseUrl}${pagePath}`;
document.head.appendChild(xDefaultLink);
// ============================================
// Meta Pixel Code
// ============================================
const META_PIXEL_ID = '2004944727113447';
if (typeof window !== 'undefined') {
  !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}
// ============================================
// Google Tag (gtag.js) - AW-18109195332
// ============================================
const GOOGLE_ADS_ID = 'AW-18109195332';
const gtagScript = document.createElement('script');
gtagScript.async = true;
gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
document.head.appendChild(gtagScript);
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    fbq: any;
    _fbq: any;
  }
}
window.dataLayer = window.dataLayer || [];
window.gtag = function gtag() {
  window.dataLayer.push(arguments);
};
window.gtag('js', new Date());
window.gtag('config', GOOGLE_ADS_ID);
// ============================================
// Render App
// ============================================
render(<App data-id="element-536" />, document.getElementById('root'));